import * as React from 'react';
import styled from 'styled-components';

interface UploadImageIconProps extends React.SVGProps<SVGSVGElement> {
  className?: string;
}

export const UploadImageIcon: React.FC<UploadImageIconProps> = ({
  className,
  ...props
}) => (
  <svg viewBox="0 0 28 20" {...props} className={className || ''}>
    <path d="M26.93,20H1.07c-.84,0-1.35-.92-.9-1.63L5.56,9.97c.35-.54,1.11-.65,1.6-.23l3.71,3.19c.51,.44,1.3,.3,1.63-.28L17.93,3.04c.41-.73,1.48-.72,1.88,.03l8.07,15.39c.37,.7-.15,1.55-.95,1.55Z" />
    <ellipse cx="7.19" cy="2.67" rx="2.69" ry="2.67" />
  </svg>
);

export default styled(UploadImageIcon)`
  circle,
  path {
    fill: ${({ theme }) => theme.colors.primary};
  }
`;
